import { z } from "zod";
export const SenderRoleEnum = z.enum(["STUDENT", "ADMIN", "AI_AGENT", "CURATOR"]);
export const ContentTypeEnum = z.enum(["text", "image", "file"]);
export const ConversationStatusEnum = z.enum(["active", "archived"]);
export const RecipientTypeEnum = z.enum(["admin", "curator"]);
export const MessageSchema = z.object({
    message_id: z.string(),
    sender_uid: z.string(),
    sender_role: SenderRoleEnum,
    content: z.string(),
    content_type: ContentTypeEnum.default("text"),
    created_at: z.string(),
    metadata: z.record(z.string(), z.unknown()).optional(),
});
export const ConversationSchema = z.object({
    user_uid: z.string(),
    user_name: z.string().nullable().optional(),
    user_avatar: z.string().nullable().optional(),
    last_message_text: z.string().nullable().optional(),
    last_message_at: z.string().nullable().optional(),
    unread_count_admin: z.number().default(0),
    unread_count_user: z.number().default(0),
    status: ConversationStatusEnum.default("active"),
    created_at: z.string(),
    // "admin" (default) or "curator" — determines who sees this conversation
    recipient_type: RecipientTypeEnum.nullable().optional(),
});
export const SendMessagePayloadSchema = z.object({
    content: z.string().min(1).max(5000),
    content_type: ContentTypeEnum.default("text"),
    recipient_type: RecipientTypeEnum.optional(),
});
export const BulkMessagePayloadSchema = z.object({
    user_uids: z.array(z.string()).min(1).max(200),
    content: z.string().min(1).max(5000),
    content_type: ContentTypeEnum.default("text"),
});
export const BulkEmailPayloadSchema = z.object({
    emails: z.array(z.string().email()).min(1).max(200),
    subject: z.string().min(1).max(200),
    body_html: z.string().min(1).max(50000),
    body_text: z.string().optional(),
});
